export default __webpack_public_path__ + "static/media/nihlbi-logo.89dc2e39.png";